import React from 'react';

export const IconWarningItem = ({ color, width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.41093 3.84195C7.11354 2.71935 8.88646 2.71935 9.58907 3.84195L13.7562 10.4999C14.4534 11.6139 13.5724 13 12.1671 13H3.83292C2.42764 13 1.54663 11.6139 2.24385 10.4999L6.41093 3.84195Z" fill="#E02828"/>
      <path d="M8 10.9924V11V10.9924Z" fill={color}/>
      <path d="M8 6V9M8 10.9924V11" stroke="white" />
    </svg>
  )
}